import { GlobalState } from "domain/types";
import { REQUEST_STATUS } from "lib/types";
import { createSelector } from "reselect";

export const getCoreState = (state: GlobalState) => state.core;

export const getValidateFetchStatus = createSelector(
  getCoreState,
  (state) => state.validateAddressRequestStatus,
);
export const getProductData = createSelector(
  getCoreState,
  (state) => state.product,
);
export const getProductDataRequestStatus = createSelector(
  getCoreState,
  (state) => state.productDataRequestStatus,
);
export const getBillEstimateFetchStatus = createSelector(
  getCoreState,
  (state) => state.billingEstimateRequestStatus,
);
export const getBillEstimates = createSelector(
  getCoreState,
  (state) => state.billEstimates,
);

export const getEstimatedUsageType = createSelector(
  getCoreState,
  (state) => state.estimatedUsageType,
);

export const getSelectedAddress = createSelector(
  getCoreState,
  (state) => state.selectedAddress,
);
export const getFlickAccountError = createSelector(
  getCoreState,
  (state) => state.flickAccountError,
);

export const getSelectedEligibilityType = createSelector(
  getCoreState,
  (state) => state.selectedEligibilityType,
);

export const getEligibleAddresses = createSelector(
  getCoreState,
  (state) => state.eligibleAddresses,
);

export const getUpdateFlickSignUpRequestStatus = createSelector(
  getCoreState,
  (state) => state.updateFlickSignUpRequestStatus,
);

export const getFlickSignUpRequestStatus = createSelector(
  getCoreState,
  (state) => state.flickSignUpRequestStatus,
);

export const getFlickUserId = createSelector(
  getCoreState,
  (state) => state.flickUserId,
);
export const getTransactionId = createSelector(
  getCoreState,
  (state) => state.transactionId,
);

export const getCCAuthSuccessful = createSelector(
  getCoreState,
  (state) =>
    state.windcaveAuthorisationRequestStatus === REQUEST_STATUS.Fulfilled,
);

export const getSignUpState = createSelector(
  getCoreState,
  (state) => state.signUpState,
);

export const getCurrentFormStep = createSelector(
  getCoreState,
  (state) => state.currentFormStep,
);

export const getPartialSignUpDialogState = createSelector(
  getCoreState,
  (state) => state.partialSignUpDialogOpen,
);

export const getPromoCode = createSelector(
  getCoreState,
  (state) => state.promoCode,
);

export const getUser = createSelector(getCoreState, (state) => state.user);
export const getUserDetails = createSelector(getUser, (user) => user.details);
export const getUserPayment = createSelector(getUser, (user) => user.payment);
export const getUserProperty = createSelector(getUser, (user) => user.property);

export const getUserVerifiedDetail = createSelector(
  getUserDetails,
  (details) => details.mobileNumber,
);

export const getCreationSource = createSelector(getCoreState, (state) => {
  return state.creationSource;
});

export const getLeadSource = createSelector(getCoreState, (state) => {
  return state.leadSource;
});

export const getAvailableProducts = createSelector(
  getCoreState,
  (state) => state.availableProducts,
);

export const getUserChecks = createSelector(
  getCoreState,
  (state) => state.user.checks,
);

export const getSignUpPaymentType = createSelector(
  getCoreState,
  (state) => state.signUpPaymentType,
);
